export const BLACKLISTED_CATEGORY = "Credit Cards & Debit Cards";
export const BLACKLISTED_PARTNER = "universal-orlando-resort";

export function isBlacklistedFromShipping(category: string, partnerSlug: string) {
  return category === BLACKLISTED_CATEGORY && partnerSlug === BLACKLISTED_PARTNER;
}
